(function() {
  const initSizeChart = () => {
    const bridge = document.getElementById("sizechart-content");
    const dataSet = window.__SIZECHARTS__;
    const btn = document.getElementById("open-sizechart");
    const modal = document.getElementById("sizechart-modal");
    const wrapper = document.getElementById("sizechart-wrapper-main");
    const injected = document.getElementById("sizechart-injected");

    if (!bridge || !dataSet || !injected) return;

    // --- LOGICA MULTI-TAG ---
    // Recuperiamo la stringa dei tag (separati da virgola)
    const rawTags = bridge.getAttribute("data-all-tags") || "";
    const tagsArray = rawTags.split(",");
    let validTag = null;
    let chart = null;

    // Troviamo il primo tag che esiste nel database JS
    for (let tag of tagsArray) {
      const cleanTag = tag.trim();
      if (dataSet[cleanTag]) {
        validTag = cleanTag;
        chart = dataSet[cleanTag];
        break; 
      }
    }

    // Se non troviamo match, nascondiamo tutto e usciamo
    if (!chart) {
      if (wrapper) wrapper.style.display = "none";
      if (btn) btn.style.display = "none";
      return;
    }

    // Se arriviamo qui, il tag è valido: mostriamo il bottone
    if (wrapper) {
      wrapper.style.setProperty("display", "flex", "important");
    }
    if (btn) {
      btn.style.setProperty("display", "inline-flex", "important");
    }

    let unit = "imperial"; 

    const draw = () => {
      const data = chart[unit];
      if (!data) return;
      
      let html = '<div class="table-responsive"><table style="width:100%; border-collapse: collapse;"><thead><tr>';
      data.headers.forEach(h => html += `<th style="padding:12px 10px; border-bottom:2px solid var(--color-border); text-align:left; font-family: var(--font-heading-family); font-size: 13px;">${h}</th>`);
      html += '</tr></thead><tbody>';
      data.rows.forEach(row => {
        html += '<tr>';
        data.headers.forEach(h => html += `<td style="padding:10px; border-bottom:1px solid var(--color-border); font-size: 13px;">${row[h] || ""}</td>`);
        html += '</tr>';
      });
      html += '</tbody></table></div>';
      
      const unitText = unit === "imperial" ? "inches" : "centimeters";
      html += `<p style="margin-top:15px; font-size:12px; opacity: 0.7;">Measurements are in <strong>${unitText}</strong>.</p>`;
      injected.innerHTML = html;
    };

    draw();

    // Toggle Unità (Imperial/Metric)
    modal.querySelectorAll(".unit-btn").forEach(ub => {
      ub.onclick = (e) => {
        e.preventDefault();
        modal.querySelectorAll(".unit-btn").forEach(b => b.classList.remove("active"));
        ub.classList.add("active");
        unit = ub.getAttribute("data-unit");
        draw();
      };
    });

    const toggleModal = (show) => {
      modal.style.display = show ? "flex" : "none";
      document.documentElement.style.overflow = show ? "hidden" : "";
      if (show) setTimeout(() => modal.classList.add("active"), 10);
      else modal.classList.remove("active");
    };

    if (btn) btn.onclick = (e) => { e.preventDefault(); toggleModal(true); };
    
    const closeX = document.getElementById("close-sizechart-x");
    if (closeX) closeX.onclick = () => toggleModal(false);
    
    modal.onclick = (e) => { if (e.target === modal) toggleModal(false); };
  };

  // --- ESECUZIONE ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChart);
  } else {
    initSizeChart();
  }

  // Supporto per i temi moderni (Tinker/Impulse) quando cambiano i contenuti
  document.addEventListener('variant:change', () => setTimeout(initSizeChart, 100));
  document.addEventListener('shopify:section:load', initSizeChart);
})();